import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path d="M5.64196714,9.1954304 L11.722162,11.222162 L9.6954304,5.14196714 L4.12191842,3.62191842 L5.64196714,9.1954304 Z M2.69669914,2.19669914 L10.4748737,4.31801948 L13.3033009,12.8033009 L4.81801948,9.97487373 L2.69669914,2.19669914 Z" transform="rotate(45 8 7.5)"/>
  </svg>
);
